import Vue from 'vue';
import VueRouter from 'vue-router';

import { ModuleRegistry } from '@ag-grid-community/core';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
ModuleRegistry.registerModules([MasterDetailModule, RichSelectModule, ExcelExportModule]);

const availablePlayers = () => import('./AvailablePlayers.vue');
const teamNeeds = () => import('./TeamNeeds.vue');
const SvCalculator = () => import('./SvCalculator.vue');
const DecisionTools = () => import('./Decisions.vue');
const dfas = () => import('./DFA.vue');
const OfferTracker = () => import('./OfferTracker.vue');
const ContractView = () => import('./ContractView/ContractView.vue');
import { AppConstantPlugin } from 'library/plugins/appConstants/index';

Vue.use(AppConstantPlugin);

Vue.use(VueRouter);

const routes = [
  { name: 'available-players', path: '/available-players', component: availablePlayers },
  { name: 'team-needs', path: '/', component: teamNeeds },
  { name: 'dfas', path: '/dfas', component: dfas },
  { name: 'player-adj', path: '/player-adj', component: SvCalculator },
  { name: 'contract-view', path: '/contract-view', component: ContractView },
  { name: 'offer-tracker', path: '/offer-tracker', component: OfferTracker },
];

const router = new VueRouter({
  routes,
});

const app = new Vue({
  router,
  render: (h) => h(DecisionTools),
}).$mount('#decision-tools');
